<template>
  <div v-if="count" class="navbar-item dropdown">
    <a
      :href="count ? '/cart' : '#'"
      :class="isEmpty ? 'cart-icon-empty' : ''"
      class="dropdown-toggle cart-icon"
      role="button"
      aria-expanded="false"
    >
      <span class="amount">
        {{ count }}
      </span>
      <i class="fa fa-shopping-cart" />
    </a>
    <div class="drop-down is-hidden-touch">
      <ul v-if="products.length">
        <li v-for="p in products" :key="p.id">
          <div class="product no-margin">
            <a :href="p.url" title="View product" class="info">
              <div class="thumbnail">
                <img :src="p.images.thumbnail" />
                <div class="qty">{{ $t('common.qty') }}: {{ p.quantity }}</div>
              </div>
              <div class="description">
                <div class="name" v-text="truncate(p.name)" />
                <div class="price-and-discount">
                  <div
                    :class="p.discount ? 'price--with-discount' : ''"
                    class="price"
                    v-html="formatPrice(p.price, p.quantity)"
                  />
                  <div
                    v-if="p.discount"
                    class="discount"
                    v-html="formatPrice(p.discount + p.price, p.quantity)"
                  />
                </div>
              </div>
            </a>
            <a
              :title="$t('cart.remove')"
              href="#"
              class="remove"
              @click.prevent="removeFromCart(p)"
            >
              <i class="fa fa-remove" />
            </a>
          </div>
          <div class="fading-line mt-1 mb-1" />
        </li>
        <li>
          <div class="level">
            <div class="level-left">
              <div class="price price--total">
                <div class="final" v-html="formatPrice(total)" />
              </div>
            </div>
            <div class="level-right">
              <a href="/cart" class="button is-primary is-outlined">
                {{ $t('cart.checkout') }}
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Cart from '../../mixins/Cart';

export default Vue.extend({
  name: 'SmallCart',

  mixins: [Cart]
});
</script>
